import { isNotEmptyObject } from './isNotEmptyObject';

export function buildAttributesWithName(name: any, attrObject: any): any {
	return isNotEmptyObject(attrObject) ? { [name]: attrObject } : undefined;
}
